import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Listings from './components/Listings';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './index.css';

function App() {
  return (
    <div className="font-sans text-slate-900 bg-white selection:bg-amber-200 selection:text-amber-900">
      <Navbar />
      <Hero />
      <About />
      <Listings />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;